import React, { createContext, useCallback, useContext, useState } from "react";

const CheckoutContext = createContext();

export const useCheckout = () => useContext(CheckoutContext);

export const CheckoutProvider = ({ children }) => {
  const [triggerPaymentMethodEvent, setTriggerPaymentMethodEvent] = useState(false);
  const [clientIp, setClientIp] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [paymentMethodName, setPaymentMethodName] = useState("");
  const [platformName, setPlatformName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  // Merchant branding — surfaced here so any modal / overlay can pick it up
  // without prop-drilling through the integration form layer.
  const [brandColor, setBrandColor] = useState("");
  const [merchantName, setMerchantName] = useState("");
  const [estimatedOrder, setEstimatedOrder] = useState(null);
  const [sessionTrial, setSessionTrial] = useState(null);
  const [forceTrialPeriodDays, setForceTrialPeriodDays] = useState(null);
  
  // Transaction data for redirect handling
  const [transactionId, setTransactionId] = useState("");
  const [transactionStatus, setTransactionStatus] = useState(null);
  const [hostedPageRedirect, setHostedPageRedirect] = useState("");
  const [isHostedPageMode, setIsHostedPageMode] = useState(false);

  /** Generic shopper message after a failed hosted CIT redirect (3DS return, etc.). */
  const [citPaymentErrorMessage, setCitPaymentErrorMessage] = useState(null);
  /** Open the payment method drawer used before the failed attempt. */
  const [hostedPaymentSelection, setHostedPaymentSelection] = useState(null);
  /** Pending CIT payload to restore after a hosted page reload (PIX QR, UPI redirect). */
  const [pendingPaymentResume, setPendingPaymentResume] = useState(null);

  // const triggerPaymentEvent = () => setTriggerPaymentMethodEvent(true);
  const triggerPaymentEvent = useCallback(async () => {
    setTransactionStatus(null);
    setTriggerPaymentMethodEvent(true)
  }, []);
  const resetTrigger = () => setTriggerPaymentMethodEvent(false);

  return (
    <CheckoutContext.Provider
      value={{
        triggerPaymentMethodEvent,
        triggerPaymentEvent,
        resetTrigger,
        clientIp,
        setClientIp,
        clientCountry,
        setClientCountry,
        setPaymentMethodName,
        setPlatformName,
        paymentMethodName,
        platformName,
        logoUrl,
        setLogoUrl,
        brandColor,
        setBrandColor,
        merchantName,
        setMerchantName,
        estimatedOrder,
        setEstimatedOrder,
        sessionTrial,
        setSessionTrial,
        forceTrialPeriodDays,
        setForceTrialPeriodDays,
        transactionId,
        setTransactionId,
        transactionStatus,
        setTransactionStatus,
        hostedPageRedirect,
        setHostedPageRedirect,
        isHostedPageMode,
        setIsHostedPageMode,
        citPaymentErrorMessage,
        setCitPaymentErrorMessage,
        hostedPaymentSelection,
        setHostedPaymentSelection,
        pendingPaymentResume,
        setPendingPaymentResume,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};
